export const formatPrice = (price: string | number, currency: string) => {
	const tempPrice = Number(price);

	const format = new Intl.NumberFormat('es-MX', {
		style: 'currency',
		currency,
	}).format(tempPrice);

	return format;
};
